export const HOME = "/";

export const CITY = "/city/:city";
export const CITY_WD = "/withdriver/city/:city";
export const CAR_FINDING = "/find/filter";
export const CAR_FINDING_WD = "/withdriver/find/filter";
export const CAR_DETAIL = "/car/:carName/:carId";
export const CAR_DETAIL_WD = "/car/wd/:carName/:carId";
export const TRIP_DETAIL = "/trip/detail/:tripId";
export const PAYMENT = "/payment/:tripId";

export const PROFILE = "/profile/:userId";

export const ACCOUNT = "/account";
export const MY_TRIPS = "/mytrips";
export const MY_CARS = "/mycars";
export const MY_FAVS = "/myfavs";
export const MY_REWARD = "/myreward";
export const MY_ADDRESS = "/myaddress";
export const DELETE_ACCOUNT = "/deleteaccount";

export const OWNER_REGISTER = "/owner/register";
export const GPS_REGISTER = "/registergps";

export const INSURANCE = "/insurance";
export const INSURANCE_REGISTER = "/insurance/register";
export const INSURANCE_TNDS = "/tnds/register";

export const CAR_REGISTER_SD = "/carregister/selfdrive";
export const CAR_REGISTER_WD = "/carregister/withdriver";
export const CAR_REGISTER = "/carregister/:mode";
export const MODE_REGISTER = "/carregistermode";
export const CAR_SETTING = "/carsetting/:carId";
export const CONTRACT = "/contract";
export const CONTRACT_SD = "/contract/sd";
export const CONTRACT_WD = "/contract/wd";
export const CALENDARS = "/calendars";

/* Car Subcription */
export const CS_FINDING = "/carsubscription/find/filter";
export const CS_DETAIL = "/carsubscription/:carName/:skuGroupId";
export const CS_TRIPS = "/mycstrips";
// export const CS_ORDER_DETAIL = "/subcription/detail/:vModelId";

export const GPS = "/gps";
export const GPS_SLEEP = "/gps/sleep";

export const MY_WALLET = "/mywallet";
export const MY_MONTHLY_REPORT = "/mymonthlyreport/:month";

export const ABOUT_US = "/aboutus";
export const M_ABOUT_US = "/aboutus/mobile";
export const WHY = "/whyus";
export const M_WHY = "/whyus/mobile";
export const PRIVACY = "/privacy";
export const M_PRIVACY = "/privacy/mobile";
export const REGU = "/regu";
export const M_REGU = "/regu/mobile";
export const TERMS = "/terms";
export const M_TERMS = "/terms/mobile";
export const PERSONAL_INFO = "/personalinfo";
export const M_PERSONAL_INFO = "/personalinfo/mobile";
export const RESOLVE_CONFLIC = "/resolveconflic";
export const M_RESOLVE_CONFLIC = "/resolveconflic/mobile";
export const HOW_IT_WORK = "/howitwork";
export const HOW_IT_WORK_OWNER = "/howitwork#owner";
export const M_HOW_IT_WORK = "/howitwork/mobile";
export const BOOKING_HOW_TO = "/bookinghowto";
export const M_BOOKING_HOW_TO = "/bookinghowto/mobile";
export const MOMO_BOOKING_HOW_TO = "/bookinghowto/momo";
export const OWNER_GUIDE = "/ownerguide";
export const M_OWNER_GUIDE = "/ownerguide/mobile";
export const PAYMENT_HOW_TO = "/paymenthowto";
export const M_PAYMENT_HOW_TO = "/paymenthowto/mobile";
export const CAREER = "/career";

export const BLOGS = "/blogs";
export const BLOG_DETAIL_ID = "/blog/:blogId";
export const BLOG_DETAIL_TITLE = "/blog/:blogTitle/:blogId";

export const FAQS = "/faqs";
export const M_FAQS = "/faqs/mobile";
export const R_FAQS = "/faqs/renter";
export const FAQ_DETAIL = "/faq/:groupName/:groupId";
export const M_FAQ_DETAIL = "/faq/:groupName/:groupId/mobile";
export const R_FAQ_DETAIL = "/faq/:groupName/:groupId/renter";

export const LOGIN = "/login";
export const RESET_PW = "/resetpw";

export const installApp = "https://app.adjust.com/liet8yx?deep_link=mioto%3A%2F%2F";
export const installAndroid = "https://app.adjust.com/emjwus3?redirect_ios=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.mioto.mioto%26hl%3Dvi%26gl%3Dvn&redirect_windows=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.mioto.mioto%26hl%3Dvi%26gl%3Dvn";
export const installIOS = "https://app.adjust.com/2z7e2t1?redirect_android=https%3A%2F%2Fapps.apple.com%2Fvn%2Fapp%2Fmioto-%25E1%25BB%25A9ng-d%25E1%25BB%25A5ng-thu%25C3%25AA-xe%2Fid1316420500%3Fl%3Dvi&redirect_windows=https%3A%2F%2Fapps.apple.com%2Fvn%2Fapp%2Fmioto-%25E1%25BB%25A9ng-d%25E1%25BB%25A5ng-thu%25C3%25AA-xe%2Fid1316420500%3Fl%3Dvi"

export const SUPPORT_APP = "/support"
